module.exports = __webpack_public_path__ + "static/media/10.74c1e6fc.jpg";